export type Weekday = 0 | 1 | 2 | 3 | 4 | 5 | 6

export interface OpeningHoursGroup {
    days: Weekday[]
    label: string
    openedFrom: number
    openedTo: number
}

export const OPENING_HOURS: OpeningHoursGroup[] = [
    { days: [1], label: "pondělí", openedFrom: 7 * 60 + 30, openedTo: 20 * 60 },
    { days: [2, 3, 4], label: "úterý—čtvrtek", openedFrom: 7 * 60 + 30, openedTo: 22 * 60 },
    { days: [5, 6], label: "pátek—sobota", openedFrom: 7 * 60 + 30, openedTo: 23 * 60 },
    { days: [0], label: "neděle", openedFrom: 7 * 60 + 30, openedTo: 20 * 60 },
]

export type OpeningStatusType = "opensToday" | "closesToday" | "opensTomorrow"

export interface OpeningStatus {
    type: OpeningStatusType
    time: string
}

const PRAGUE_TIME = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Europe/Prague",
    weekday: "short",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
})

const WEEKDAYS: { [key: string]: Weekday } = {
    Sun: 0,
    Mon: 1,
    Tue: 2,
    Wed: 3,
    Thu: 4,
    Fri: 5,
    Sat: 6,
}

export function formatOpeningTime(minutes: number): string {
    const hours = Math.floor(minutes / 60)
    const mins = minutes % 60

    return `${hours}:${mins < 10 ? "0" : ""}${mins}`
}

export function formatOpeningRange(hours: OpeningHoursGroup): string {
    return `${formatOpeningTime(hours.openedFrom)}—${formatOpeningTime(hours.openedTo)}`
}

export function getOpeningHours(day: Weekday): OpeningHoursGroup {
    return OPENING_HOURS.find((hours) => hours.days.indexOf(day) !== -1)
}

function getPragueDayAndTime(date: Date): { day: Weekday, minutes: number } {
    const parts = PRAGUE_TIME.formatToParts(date)
    const weekday = parts.find((part) => part.type === "weekday")
    const hour = parts.find((part) => part.type === "hour")
    const minute = parts.find((part) => part.type === "minute")

    return {
        day: WEEKDAYS[weekday.value],
        minutes: Number(hour.value) * 60 + Number(minute.value),
    }
}

export function getOpeningStatus(date: Date = new Date()): OpeningStatus {
    const current = getPragueDayAndTime(date)
    const today = getOpeningHours(current.day)

    if (current.minutes < today.openedFrom) {
        return { type: "opensToday", time: formatOpeningTime(today.openedFrom) }
    }

    if (current.minutes < today.openedTo) {
        return { type: "closesToday", time: formatOpeningTime(today.openedTo) }
    }

    const tomorrow = getOpeningHours(((current.day + 1) % 7) as Weekday)

    return { type: "opensTomorrow", time: formatOpeningTime(tomorrow.openedFrom) }
}
